module.exports = __webpack_public_path__ + "static/media/headphone-desktop-ui.b6d9f038.mp4";